<agr-form>
  <div class="measurements-loading-order" data-test="measurements-loading-order">
    <mat-form-field class="full-width-field" appearance="outline">
      <mat-label>{{
        'measurements.wizard.loading-order.component-placeholder' | translate
      }}</mat-label>
      <mat-select
        [formControl]="rationComponentFormControl"
        (selectionChange)="addRationComponent($event)"
        data-test="measurements-loading-order__ration_component"
      >
        <mat-option
          *ngFor="let rationComponent of rationComponents$ | async"
          [id]="rationComponent.id + ''"
          [value]="rationComponent"
        >
          {{ 'measurements.wizard.loading-order.type.' + rationComponent.name | translate }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-card appearance="outlined" class="border-all--gray4 mat-elevation-z0">
      <mat-card-content class="measurements-loading-order__table">
        <agr-table
          [config]="tableConfig"
          [emptyImage]="false"
          [emptyTitle]="'measurements.wizard.loading-order.empty-title' | translate"
          [emptyDescription]="'measurements.wizard.loading-order.empty-subtitle' | translate"
        >
        </agr-table>
        <ng-template #nameColumn let-row="row">
          <div class="flex--row spacing--margin-left">
            <span data-test="measurements-loading-order__loading-order">{{
              'measurements.wizard.loading-order.type.' + row.name | translate
            }}</span>
          </div>
        </ng-template>
      </mat-card-content>
    </mat-card>

    <mat-form-field
      class="full-width-field spacing--margin-top mat-form-field__no-spacing"
      subscriptSizing="dynamic"
    >
      <mat-label>{{ 'measurements.wizard.loading-order.total-mixing-time' | translate }}</mat-label>
      <input matInput agrNumber [formControl]="mixingTimeFormControl" [step]="1" />
    </mat-form-field>
  </div>
</agr-form>
